// extracted by mini-css-extract-plugin
export default {"button":"close-button_button__DArfN","text":"close-button_text__xfnO1","icon":"close-button_icon__0nU6W"};